// src/lib/animations.ts
var springSnappy = { type: "spring", stiffness: 500, damping: 35 };
var springSmooth = { type: "spring", stiffness: 400, damping: 30 };
var springBouncy = { type: "spring", stiffness: 400, damping: 15 };
var springGentle = { type: "spring", stiffness: 200, damping: 22 };
var fadeSlideUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 }
};
var fadeScale = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 }
};
var slideFromRight = {
  initial: { x: "100%" },
  animate: { x: 0 },
  exit: { x: "100%" }
};
var slideFromLeft = {
  initial: { x: -20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: -20, opacity: 0 }
};
var slideFromTop = {
  initial: { y: -20, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: -20, opacity: 0 }
};
var fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
};
var staggerContainer = (stagger = 0.05) => ({
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: stagger }
  }
});
var staggerItem = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0 }
};
var chatBubble = {
  initial: { opacity: 0, y: 20, scale: 0.9 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, scale: 0.85 },
  transition: { type: "spring", stiffness: 200, damping: 20, mass: 0.2 }
};
var duration = {
  fast: 0.1,
  normal: 0.15,
  slow: 0.25
};

export {
  springSnappy,
  springSmooth,
  springBouncy,
  springGentle,
  fadeSlideUp,
  fadeScale,
  slideFromRight,
  slideFromLeft,
  slideFromTop,
  fadeIn,
  staggerContainer,
  staggerItem,
  chatBubble,
  duration
};
//# sourceMappingURL=chunk-X5OIVVU7.js.map